/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Filter/Protocol/Active
 * @desc Active filter component for protocol
 */

import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type {
  ExperimentWorkflowFilterProtocolActiveProps,
  ProtocolChildrenProps,
  ProtocolCollectionChildrenProps,
} from './types';

export const ExperimentWorkflowFilterProtocolActive: React.FC<
  ExperimentWorkflowFilterProtocolActiveProps
> = ({ clearParams, searchParams }) => (
  <>
    {'protocol_id' in searchParams && (
      <EntityReadEntityContainer
        entityName={Protocol.entityName}
        id={searchParams.protocol_id as number}
      >
        {({ entity: protocol }: ProtocolChildrenProps) => {
          return protocol ? (
            <RemoveLabel
              icon={ICONS.protocol_collection.primary}
              name={`${protocol.nameAndVersion}`}
              onRemoveClick={
                clearParams && (() => clearParams(['protocol_id']))
              }
            />
          ) : null;
        }}
      </EntityReadEntityContainer>
    )}
    {'protocol_collection_id' in searchParams && (
      <EntityReadEntityContainer
        entityName={ProtocolCollection.entityName}
        id={searchParams.protocol_collection_id as number}
      >
        {({
          entity: protocolCollection,
        }: ProtocolCollectionChildrenProps) => {
          return protocolCollection ? (
            <RemoveLabel
              icon={ICONS.protocol_collection.primary}
              name={`${protocolCollection.displayName}`}
              onRemoveClick={
                clearParams &&
                (() => clearParams(['protocol_collection_id']))
              }
            />
          ) : null;
        }}
      </EntityReadEntityContainer>
    )}
  </>
);
